// src/context/LoaderContext.tsx
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";
import { loaderController } from "../utils/loaderController";

const LoaderContext = createContext<{
  isLoading: boolean;
}>({ isLoading: false });

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loaderController.setHooks(
      () => setIsLoading(true),
      () => setIsLoading(false),
    );
  }, []);

  return (
    <LoaderContext.Provider value={{ isLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
